import createJSON from './create-json';
export * from './raw-json';
export * from './types';
export { createJSON };
export default createJSON({});
//# sourceMappingURL=index.js.map